import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
/** Components Import */
import RequireAuth from './RequireAuth';
import Login from '../Scripts/Login/LoginFunction'; // Login
import Drawer from './Drawer'; // Menu Drawer
import Home from '../Scripts/Home/HomeFunction'; // Home
import MyPage from '../Scripts/MyPage/MyPageFunction'; // MyPage
import RouterCommon from '../Components/RouterCommon/RouterCommon';
import RouterContainer from '../Components/Ui/RouterContainer';
import ErrorBoundary from '../Components/ErrorBoundary/ErrorBoundary';
import { ErrorDialog } from '../Components/MUIs';
import KOSHA_TEMP_01F from '../Scripts/Etc/KoshaRiskTemp/KOSHA_TEMP_01F';
import { DynamicRouteWrapper } from './DynamicRouteWrapper';
import ManualViewerPage from '../Components/Manual/ManualViewerPage';
import IdentityMokCallback from '../Scripts/Login/IdentityMokCallback';

export default function Routers() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <RouterContainer />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/mok-callback" element={<IdentityMokCallback />} />
          <Route path="/manual-viewer" element={<ManualViewerPage />} />
          <Route
            element={
              <RequireAuth>
                <Drawer />
              </RequireAuth>
            }
          >
            <Route path="/Home" element={<Home />} />
            <Route path="/MyPage" element={<MyPage />} />
            {/* 시스템 정보 */}
            <Route path="/Code" element={<RouterCommon />} />
            <Route path="/Menu" element={<RouterCommon />} />
            <Route path="/Auth" element={<RouterCommon />} />
            <Route path="/Language" element={<RouterCommon />} />
            <Route path="/CompanyMenu" element={<RouterCommon />} />
            <Route path="/IndustryMenu" element={<RouterCommon />} />
            <Route path="/DataMigration" element={<RouterCommon />} />
            {/* 기준정보 관리 */}
            <Route path="/Company" element={<RouterCommon />} />
            <Route path="/Plant" element={<RouterCommon />} />
            <Route path="/Member" element={<RouterCommon />} />
            <Route path="/Department" element={<RouterCommon />} />
            <Route path="/Gongjong" element={<RouterCommon />} />
            {/* 공지 / 게시 */}
            <Route path="/NoticeBoard" element={<RouterCommon />} />
            <Route path="/Notice" element={<RouterCommon />} />
            <Route path="/Notice1" element={<RouterCommon />} />
            <Route path="/Notice2" element={<RouterCommon />} />
            {/* <Route path="/LawSummary" element={<RouterCommon />} />
          <Route path="/SafetySigns" element={<RouterCommon />} />
          <Route path="/SafetyRules" element={<RouterCommon />} />
          <Route path="/PenaltyRules" element={<RouterCommon />} /> */}
            {/* 기타 */}
            <Route path="/Schedule" element={<RouterCommon />} />
            <Route path="/Aicall" element={<RouterCommon />} />
            <Route path="/AicallManager" element={<RouterCommon />} />
            <Route path="/AicallStatus" element={<RouterCommon />} />
            <Route path="/AiDocumentManager" element={<RouterCommon />} />

            {/* 안전보건관리체제 */}
            <Route path="/PolicyAndGoals" element={<RouterCommon />} />
            <Route path="/BudgetManagement" element={<RouterCommon />} />
            <Route path="/SafetyPersonnel" element={<RouterCommon />} />
            <Route path="/EmergencyManual" element={<RouterCommon />} />
            <Route path="/SubcontractorManagement" element={<RouterCommon />} />
            <Route path="/LegalCompliance" element={<RouterCommon />} />
            <Route path="/SeriousAccidentAct" element={<RouterCommon />} />
            <Route path="/SeriousAccidentAct1" element={<RouterCommon />} />
            <Route path="/SafetyCommittee" element={<RouterCommon />} />
            {/* 위험성평가 */}
            <Route path="/RiskEvaluation" element={<RouterCommon />} />
            {/* 안전작업 관리 */}
            <Route path="/SafeWorkProcedure" element={<RouterCommon />} />
            <Route path="/SafetyWorkManagement" element={<RouterCommon />} />
            <Route path="/PPEManagement" element={<RouterCommon />} />
            <Route path="/HazardousMachines" element={<RouterCommon />} />
            {/* 교육 및 훈련 */}
            <Route path="/TrainingPage" element={<RouterCommon />} />
            <Route
              path="/MultiTrainingPage"
              element={<DynamicRouteWrapper menuId="MultiTrainingPage" />}
            />
            <Route path="/SafetyHealthTraining" element={<RouterCommon />} />
            {/* 보건관리 */}
            <Route path="/HazardousMaterials" element={<RouterCommon />} />
            <Route path="/HealthCheckup" element={<RouterCommon />} />
            <Route path="/WorkEnvironment" element={<RouterCommon />} />
            {/* <Route path="/MusculoskeletalSurvey" element={<RouterCommon />} /> */}
            {/* 산업재해 */}
            <Route path="/AccidentReport" element={<RouterCommon />} />
            <Route path="/Accidents" element={<RouterCommon />} />
            {/* 안전신문고 / 위험성평가하기 — menuInfo(서버 필터) + routeConfig proId 분기 */}
            <Route
              path="/SuggestionList"
              element={<DynamicRouteWrapper menuId="SuggestionList" />}
            />
            <Route
              path="/RiskNearMiss"
              element={<DynamicRouteWrapper menuId="RiskNearMiss" />}
            />
            {/* 고객사 전용 헬프데스크 */}
            <Route path="/HelpDesk" element={<RouterCommon />} />

            {/* 대시보드 */}
            <Route path="/DashboardMain" element={<RouterCommon />} />
            <Route path="/CompanyUsageList" element={<RouterCommon />} />
            <Route path="/Revisions" element={<RouterCommon />} />
            <Route path="/KoshaRiskTemp" element={<KOSHA_TEMP_01F />} />
          </Route>
          {/* <Route
                    path="*"
                    element={
                        <RequireAuth>
                            <Login />
                        </RequireAuth>
                    }
                /> */}
        </Routes>
        <ErrorDialog />
      </ErrorBoundary>
    </BrowserRouter>
  );
}
